import React, { useState } from 'react';
import './QRCode.css';

interface QRCodeProps {
  url: string;
  size?: number;
  title?: string;
}

const QRCode: React.FC<QRCodeProps> = ({ 
  url, 
  size = 200, 
  title = "Scan to download" 
}) => {
  const [showQR, setShowQR] = useState(false);

  // Create UTM-tracked URL for QR codes
  const createTrackedUrl = (baseUrl: string) => {
    const utmParams = new URLSearchParams({
      'utm_source': 'qr_code',
      'utm_medium': 'offline',
      'utm_campaign': 'qr_conversion',
      'utm_content': 'qr_scan',
      'utm_term': 'justfun_qr'
    });
    
    return `${baseUrl}&${utmParams.toString()}`;
  };

  const trackedUrl = createTrackedUrl(url);
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(trackedUrl)}`;

  return (
    <div className="qr-code-container">
      <button 
        onClick={() => setShowQR(!showQR)} 
        className="qr-toggle-button"
      >
        📱 {showQR ? 'Hide' : 'Show'} QR Code
      </button>
      
      {showQR && (
        <div className="qr-code-modal">
          <div className="qr-code-content">
            <h3>{title}</h3>
            <div className="qr-code-image">
              <img 
                src={qrCodeUrl} 
                alt="QR Code for Android App Download"
                width={size}
                height={size}
              />
            </div>
            <p>Scan with your phone to download the JustFun Android app</p>
            <div className="qr-code-actions">
              <button 
                onClick={() => window.open(trackedUrl, '_blank')}
                className="direct-download-button"
              >
                📥 Direct Download
              </button>
              <button 
                onClick={() => setShowQR(false)}
                className="close-qr-button"
              >
                ✕ Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QRCode;
